"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepTypes = void 0;
var StepTypes;
(function (StepTypes) {
    StepTypes["SEARCH_VEHICLE_VRN_ONLY"] = "search_vehicle_vrn_only";
    StepTypes["SEARCH_VEHICLE_VRN_AND_DETAILS"] = "search_vehicle_vrn_and_details";
    StepTypes["SELECT_VEHICLE"] = "select_vehicle";
    StepTypes["CAR_CONDITION"] = "car_condition";
    StepTypes["CUSTOMER"] = "customer";
    StepTypes["VALUATION_NEXT"] = "valuation_next";
    StepTypes["VALUATION"] = "valuation";
    StepTypes["ERROR"] = "error";
    StepTypes["EXCEPTION"] = "exception";
    StepTypes["RESTRICTED_VALUATION"] = "restricted_valuation";
    StepTypes["VALUATION_VIEW"] = "valuation_view";
})(StepTypes = exports.StepTypes || (exports.StepTypes = {}));
